import React, { createContext, useState, useEffect } from 'react';

export const CartContext = createContext();

export const CartProvider = ({ children }) => {
  const [cart, setCart] = useState([]);

  useEffect(() => {
    const savedCart = localStorage.getItem('cart');
    if (savedCart) {
      try {
        setCart(JSON.parse(savedCart));
      } catch (err) {
        console.error('Error loading cart:', err);
      }
    }
  }, []);

  useEffect(() => {
    localStorage.setItem('cart', JSON.stringify(cart));
  }, [cart]);

  // ✅ qty parameter add kiya — default 1 (pehle wala behaviour same)
  const addToCart = (product, qty = 1) => {
    setCart(prev => {
      const exists = prev.find(item => item.id === product.id);
      if (exists) {
        return prev.map(item =>
          item.id === product.id
            ? { ...item, quantity: item.quantity + qty }  // qty add hoga
            : item
        );
      }
      return [...prev, { ...product, quantity: qty }];    // qty se start hoga
    });
  };

  const updateQuantity = (productId, delta) => {
    setCart(prev =>
      prev
        .map(item =>
          item.id === productId
            ? { ...item, quantity: item.quantity + delta }
            : item
        )
        .filter(item => item.quantity > 0)
    );
  };

  const removeFromCart = (productId) => {
    setCart(prev => prev.filter(item => item.id !== productId));
  };

  const clearCart = () => {
    setCart([]);
  };

  // Helper: get effective price (discounted or original)
  const getEffectivePrice = (item) => {
    const price = parseFloat(item.price);
    const disc  = parseFloat(item.discount_percent);
    if (!disc || isNaN(disc) || disc <= 0) return price;
    return parseFloat((price - (price * disc) / 100).toFixed(2));
  };

  // Total uses discounted price if available
  const getTotal = () => {
    return parseFloat(
      cart.reduce((sum, item) => sum + getEffectivePrice(item) * item.quantity, 0).toFixed(2)
    );
  };

  // Original total (before discount) — for showing savings
  const getOriginalTotal = () => {
    return parseFloat(
      cart.reduce((sum, item) => sum + parseFloat(item.price) * item.quantity, 0).toFixed(2)
    );
  };

  // Total savings across all cart items
  const getTotalSavings = () => {
    return parseFloat((getOriginalTotal() - getTotal()).toFixed(2));
  };

  const getItemCount = () => {
    return cart.reduce((sum, item) => sum + item.quantity, 0);
  };

  return (
    <CartContext.Provider
      value={{
        cart,
        addToCart,
        updateQuantity,
        removeFromCart,
        clearCart,
        getTotal,
        getOriginalTotal,
        getTotalSavings,
        getEffectivePrice,
        getItemCount
      }}
    >
      {children}
    </CartContext.Provider>
  );
};